import { render, staticRenderFns } from "./Feamization.vue?vue&type=template&id=e1b818b8&scoped=true"
import script from "./Feamization.vue?vue&type=script&lang=js"
export * from "./Feamization.vue?vue&type=script&lang=js"
import style0 from "./Feamization.vue?vue&type=style&index=0&id=e1b818b8&prod&scoped=true&lang=css"
import style1 from "./Feamization.vue?vue&type=style&index=1&id=e1b818b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b818b8",
  null
  
)

export default component.exports